import React from 'react'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import TailwindLayout from './TailwindLayout'
import themeConsumer from '../../theme/theme-consumer'

export default function ConsumerLayout(props) {
  return (
    <TailwindLayout
      menu={props.menu}
      footer={props.footer}
      cookiePrompt={props.cookiePrompt}
      consumer={true}
    >
      <StyledThemeProvider theme={themeConsumer}>
        <MuiThemeProvider theme={themeConsumer}>{props.children}</MuiThemeProvider>
      </StyledThemeProvider>
    </TailwindLayout>
  )
}
